import { render, staticRenderFns } from "./DutyPartsOwnDataView.vue?vue&type=template&id=2779ed30&scoped=true&"
import script from "./DutyPartsOwnDataView.vue?vue&type=script&lang=js&"
export * from "./DutyPartsOwnDataView.vue?vue&type=script&lang=js&"
import style0 from "./DutyPartsOwnDataView.vue?vue&type=style&index=0&id=2779ed30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2779ed30",
  null
  
)

export default component.exports